const APP_HANDLE =
  (import.meta.env.VITE_SHOPIFY_APP_HANDLE as string) ?? "codway";

// Builds an absolute Shopify admin URL pointing to a path inside this app.
// Shape: https://admin.shopify.com/store/{store-handle}/apps/{app-handle}/{path}
export function buildAdminAppUrl(path: string): string {
  const shop = window.shopify?.config?.shop || window.shopify?.shop || "";
  const storeHandle = shop.replace(/\.myshopify\.com$/, "");
  const cleanPath = path.replace(/^\/+/, "");
  return `https://admin.shopify.com/store/${storeHandle}/apps/${APP_HANDLE}/${cleanPath}`;
}
